module.exports = __webpack_public_path__ + "static/media/Cartela_H.23782e4a.svg";